'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiSocialTumblerCircular = function TiSocialTumblerCircular(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm24 26v-2.1c-0.7 0.5-1.4 0.7-2 0.7-0.3 0-0.6-0.1-1-0.3-0.2-0.1-0.3-0.3-0.4-0.5-0.1-0.2-0.1-0.7-0.1-1.4v-3.3h3v-2.1h-3v-3.2h-1.8c-0.2 0.7-0.3 1.3-0.5 1.6-0.1 0.4-0.4 0.8-0.9 1.1-0.4 0.4-0.8 0.6-1.2 0.8v1.8h1.4v4.5c0 0.5 0 1 0.2 1.3 0.1 0.3 0.3 0.6 0.7 0.9 0.2 0.3 0.6 0.5 1.1 0.7 0.6 0.1 1.1 0.2 1.5 0.2 0.5 0 1-0.1 1.5-0.2 0.5-0.1 1-0.3 1.5-0.5z m-4 9c-8.3 0-15-6.7-15-15s6.7-15 15-15 15 6.7 15 15-6.7 15-15 15z m0-26.7c-6.4 0-11.7 5.3-11.7 11.7s5.3 11.7 11.7 11.7 11.7-5.3 11.7-11.7-5.3-11.7-11.7-11.7z' })
        )
    );
};

exports.default = TiSocialTumblerCircular;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/social-tumbler-circular.js
// module id = 2188
// module chunks = 0